import { z } from 'zod';
import { SALES_PAGE_STATUSES } from '../types/enums.js';
import { salesPageContentSchema } from '../sales-page/blocks.js';
import { paginationQuerySchema, slugSchema, sortOrderSchema } from './common.js';
export const createSalesPageSchema = z.object({
    title: z.string().trim().min(2, 'Page title is required').max(200),
    slug: slugSchema.optional(),
    /** SEO / social preview. */
    metaTitle: z.string().trim().max(200).nullable().optional(),
    metaDescription: z.string().trim().max(500).nullable().optional(),
    ogImageUrl: z.string().url().max(2048).nullable().optional(),
    content: salesPageContentSchema.optional(),
});
export const updateSalesPageSchema = createSalesPageSchema.partial().refine((value) => Object.keys(value).length > 0, { message: 'Provide at least one field to update' });
/** Saving content creates a new SalesPageVersion rather than mutating in place. */
export const saveSalesPageContentSchema = z.object({
    content: salesPageContentSchema,
    /** Optional label shown in the version list, e.g. "Added testimonials". */
    changeNote: z.string().trim().max(200).optional(),
});
export const salesPageListQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(200).optional(),
    status: z.enum(SALES_PAGE_STATUSES).optional(),
    sortBy: z.enum(['createdAt', 'updatedAt', 'title']).default('updatedAt'),
    sortOrder: sortOrderSchema,
});
export const duplicateSalesPageSchema = z.object({
    title: z.string().trim().min(2).max(200).optional(),
});
//# sourceMappingURL=sales-page.js.map